// When a nosto search is made, the class "nosto-serp-content" is added to the main content area.
// This script listens for that class to be added or removed and adds/removes the class "nosto-serp-active" to the body.
// This way we can conditionally hide the Facets bar in the collection page when a nosto search is perfomed.
export const init = async function() {
    function waitForMainContent(callback) {
        const interval = setInterval(()=>{
            const targetNode = document.querySelector('#main-content');
            if (targetNode) {
                clearInterval(interval);
                callback();
            }
        }, 100);
    }
    waitForMainContent(()=>{
        const targetNode = document.querySelector('#main-content');
        if (!targetNode) {
            return;
        }
        const body = document.body;
        const updateBodyClass = ()=>{
            if (targetNode.classList.contains('nosto-serp-content')) {
                body.classList.add('nosto-serp-active');
            } else {
                body.classList.remove('nosto-serp-active');
            }
        };
        updateBodyClass();
        const observer = new MutationObserver(updateBodyClass);
        observer.observe(targetNode, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
    });
};
